import apiClient from '../api/axios';

export interface AddUnitPayload {
  type: string;
  parent_id: string | null;
  name_en: string;
  name_ar: string;
}

export const createOrganizationUnit = async (data: AddUnitPayload) => {
  const response = await apiClient.post(
    '/organization/unit', // <-- Replace with your backend endpoint
    data,
  );

  return response.data;
};
